<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
  
 <h4 v-if="createForm" slot="header" class="card-title">
    Create New Recurring Bill
    </h4>
     <h4 v-else slot="header" class="card-title">
     Edit Recurring Bill 
    </h4>
  
 <card class="form-horizontal">
   
    

    <div class="row" style="text-align:left;">
      <label class="col-sm-2 col-form-label">Title</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="title"
                  v-validate="modelValidations.Title"
                  :error="getError('Title')"
                  v-model="model.title">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 col-form-label">Description</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="description"
                  v-validate="modelValidations.description"
                  :error="getError('description')"
                  v-model="model.description">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code>Optional</code>
      </div>
    </div>
    
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Amount</label>
      <div class="col-sm-7">
        <fg-input type="text"
                  name="amount"
             	  style="width:200px"
                  v-validate="modelValidations.amount"
                  :error="getError('amount')"
                  v-model="model.amount">
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Currency</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.currency">
                    <el-option v-for="option in selects.currencies"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Billing Cycle</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.billing_cycle">
                    <el-option v-for="option in selects.billing_cycle"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    <div class="row">
      <label class="col-sm-2 col-form-label">Status</label>
      <div class="col-sm-7">
        <fg-input>
                  <el-select class="select-primary"
                             size="large"
                             placeholder=""
                             v-model="model.status">
                    <el-option v-for="option in selects.bill_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
        </fg-input>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>
    
    
     <div class="row">
      <label class="col-sm-2 col-form-label">Next Billing Date</label>
      <div class="col-sm-7">
        <div class="form-group">
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="model.deadline" type="date" placeholder="Select A Date"
              	name ="deadline"
              	:error="getError('deadline')"
              	v-bind:class="{ field_error_cs: errors.has('deadline') }"
                v-validate="modelValidations.deadline" 
              >
              </el-date-picker>
            </div>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>

 

	
	  <div class="row">
      <label class="col-sm-2 col-form-label">Notes</label>
      <div class="col-sm-7">
       <textarea 
        		 cols="45" rows="10"
                  name="new_reso_item"
                  v-model="model.notes">
       	    </textarea>
      </div>
      <div class="col-sm-3 label-on-right">
        <code></code>
      </div>
    </div>




   

  </card>
        
        
 <div slot="footer" class="text-center">
      <p-button v-if="createForm"  type="info" @click.prevent="submitNewRecurringBillForm">Submit New Recurring Bill</p-button>
      <p-button v-else  type="info" @click.prevent="editRecurringBill">Edit Recurring Bill</p-button>
    </div>
   


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
     	
    				
     
       if(this.$route.params.rbid!=0){
     		this.createForm = false;
     		
     		let uri = this.$base_url+'/api/v1/accounting/get/recurring_bill/'+ this.$route.params.rbid;
   
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.recurring_bill;
				
					swal.close();
				
			
			})

       }
       
       if(this.$route.params.eid!=0){
     
			let uri = this.$base_url+'/api/v1/entities/simple/'+ this.$route.params.eid;
			 ApiService.get(uri).then(response => {
				this.coy = response.data.entity;
				 if(this.$route.params.rbid==0){
						this.model.deadline = this.coy.date_signup_plus_one_year;
				  }
			})
      	}//get connected entity info
      
     	 	
      
    },
    
     
    data () {
      return {
        coy:[],
        variables:[],
    	eid: this.$route.params.eid,
    	oid: this.$route.params.oid,
    	createForm: true,
    	loadCommon: false,
    	loadInfo: false,
    	displayCompanyForm: false,
        model: {
          title: 'Annual Subscription Fee',
          description: '',
          amount: '',
		  currency:'SGD',
		  billing_cycle:1,
		  deadline:'',
		  category:1,
		  status:1,

        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
          deadline:{
          	required:true,
          }
          
         
          
        },
        
        selects: {
          currencies: [
            {value: "SGD", label: 'SGD'},
		   ],
		  billing_cycle:[
            {value: 1, label: 'Annually'},
		   ],
		   bill_status:[
            {value: 1, label: 'Active'},
            {value: 2, label: 'Cancelled'},
		   ],
		   category:[
            {value: 1, label: 'Annual Subscription Fee'},
		   ] 
        },
      }
    },
    methods:{
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
       displayErrorMessage(msg){
        		swal({
					  title: 'Error!',
					  text: msg,
					  type: 'error',
					  confirmButtonClass: 'btn btn-success btn-fill',
					  buttonsStyling: false
			 	})
        
        
        
        },
    	onIsCompanyRepChange(event){
       		if(this.model.is_company == 1){

       			this.displayCompanyForm = true;
       		}
       		else{
       			this.displayCompanyForm = false;
       		}
       
       },
 
       getError(fieldName) {
        return this.errors.first(fieldName)
      },
      submitNewRecurringBillForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/accounting/create/recurring_bill/'+ this.$route.params.eid;
      		ApiService.post(uri, this.model).then(response => {
      				this.$router.push( '/view-entity/'+ this.$route.params.eid);
         		
     		 })
  		  }
        
         
        })
      },///end validate+create
      editRecurringBill() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		
  		  } else {
    		let uri = this.$base_url+'/api/v1/accounting/update/recurring_bill/'+this.$route.params.rbid;
      		ApiService.post(uri, this.model).then(response => {
         			this.$router.push( '/view-entity/'+ this.$route.params.eid);
         		
     		 })
  		  }
        
         
        })
      },///end validate+edit
      
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


